<template>
  <div class="information-upload">
    <div class="content p12">
      <div class="card p12">
        <div class="msg">请上传线下就诊证明病历、挂号条、缴费单、药单等资料。（图片仅医生可见，最多上传3张）</div>
        <div class="button mt8" @click="submit('LOST')">凭证遗失/没有携带</div>
      </div>
      <div class="upload mt16 ">
        <div class="up-icon up-item" :style="itemStyle" @click="upload">
          <div class="img">
            <img
              class="icon-img"
              src="http://static.91jkys.com/activity/img/790811982e6e4e1987a87ec308e69848.FUp_1229488033066302144_"
              alt=""
            />
          </div>
          <div class="text">拍摄/相册</div>
        </div>
        <div v-for="(item, index) in imgList" class="up-item" :style="itemStyle" :key="index">
          <img
            src="https://static.91jkys.com/activity/img/9d1e2162ffa84abea4b595393dc92a0d.FUp_4233654005063413872_"
            class="del-icon"
            @click="deleteImg(item)"
            alt=""
          />
          <van-image
            width="100%"
            height="100%"
            fit="cover"
            @click.native="handlePreview(index)"
            :src="item + '?x-oss-process=image/resize,m_fill,h_200,w_200'"
          />
        </div>
      </div>
    </div>

    <footer class="footer-btns">
      <van-button type="primary" class="sub-btn" @click="submit('IMG')">
        <span class="bold">提交</span>
      </van-button>
    </footer>
  </div>
</template>

<script>
import Vue from 'vue';
import { Dialog } from '@zyf2e/capui-mobile';
import { ImagePreview } from '@zyf2e/capui-mobile';

Vue.use(ImagePreview);
export default {
  name: 'information-upload',
  data() {
    return {
      windowWidth: document.body.clientWidth,
      imgList: [],
      id: ''
    };
  },
  computed: {
    itemStyle() {
      const cwidth = this.windowWidth - 32;
      return `width: ${parseInt(cwidth * 101) / 344}px; height: ${parseInt(cwidth * 101) / 344}px; margin-right: ${
        (cwidth * 23) / 344
      }px;border-radius: 4px`;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const { doctorId } = this.$route.query;

      this.$fetch.fetchGetFileInformation({ doctorId }).then((res) => {
        const { id = '', content = '', type = '' } = res || {};
        this.id = id;

        this.imgList = content ? JSON.parse(content) : [];
      });
    },
    handlePreview(index) {
      ImagePreview({
        images: this.imgList,
        startPosition: index,
        closeable: true
      });
      // window.wx.previewImage(
      //   url, // 当前显示图片的http链接
      //   this.imgList // 需要预览的图片http链接列表
      // );
    },
    deleteImg(img) {
      Dialog.confirm({
        title: '删除照片',
        message: '是否确认删除该照片',
        confirmButtonText: '删除'
      })
        .then(() => {
          const index = this.imgList.indexOf(img);
          this.imgList.splice(index, 1);
        })
        .catch(() => {
          // on cancel
        });
    },
    async upload() {
      if (this.imgList.length >= 3) {
        return this.$toast({ className: 'middle-toast', message: `您最多上传三张图片` });
      }

      const localIds = await window.wx.getImgBase64(3 - this.imgList.length);

      this.$toast.loading({
        className: 'middle-toast',
        message: '图片上传中...'
      });

      if (localIds && localIds.length) {
        for (const localId of localIds) {
          const lacalBase64Date = await window.wx.getLocalImgData(localId);
          if (this.getBase64Size(lacalBase64Date) / 1024 / 1024 > 10) {
            return this.$toast({ className: 'middle-toast', message: `您上传的图片单张不能超过10M` });
          }

          const { data = {} } = await this.$fetch.uploadFile(this.dataURLtoFile(lacalBase64Date));
          this.$toast.clear();
          console.log('getdata', data.fileUrl);
          if (data.fileUrl) {
            this.imgList.push(data.fileUrl);
          }
        }
      }
    },
    getBase64Size(base64) {
      //获取base64字符串的大小
      if (base64) {
        // 获取base64图片byte大小
        base64 = base64.split(',')[1].split('=')[0];
        var strLength = base64.length;
        var fileLength = strLength - (strLength / 8) * 2;
        return Math.floor(fileLength); // 向下取整
      } else {
        return null;
      }
    },

    dataURLtoFile: function (dataURI, type) {
      let binary = atob(dataURI.split(',')[1]);
      let array = [];
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      let fileData = new Blob([new Uint8Array(array)], {
        type: type
      });
      let form = new FormData();
      form.append('action', 'fileUpload');
      let fileOfBlob = new File([fileData], new Date().getTime() + '.png'); // 重命名了
      form.append('file', fileOfBlob);
      return form;
    },
    submit(type) {
      const { doctorId } = this.$route.query;
      const params = {};
      if (this.id) params.id = this.id;
      if (doctorId) params.doctorId = doctorId;
      params.type = type;

      if (type === 'IMG' && !this.imgList.length) {
        this.$toast({ className: 'middle-toast', message: '请上传处方信息或病历资料' });
        return;
      }
      if (type === 'IMG') {
        params.content = JSON.stringify(this.imgList);
      }
      this.$fetch.submitFileInformation(params).then((res) => {
        if (type === 'IMG') this.$toast({ className: 'middle-toast', message: '提交成功' });
        window.wx.closeWindow();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.information-upload {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  height: 100%;
  .content {
    flex: 1;
    .card {
      background: #ebf8ff;
      border-radius: 4px;
      .msg {
        color: #595959;
        line-height: 21px;
        font-size: 14px;
      }
      .button {
        color: #1e8dff;
        font-size: 14px;
        line-height: 20px;
      }
    }
    .upload {
      display: flex;
      flex-wrap: wrap;
      .up-item {
        position: relative;
        border-radius: 4px;
        margin-bottom: 20px;
        z-index: 1;
        &:nth-child(3) {
          margin-right: 0 !important;
        }
        .del-icon {
          position: absolute;
          width: 20px;
          height: 20px;
          z-index: 222;
          left: -10px;
          top: -10px;
        }
        /deep/.van-image__img {
          border-radius: 4px;
        }
      }
      .up-icon {
        background: #f5f5f5;
        border-radius: 4px;
        .text {
          width: 100%;
          text-align: center;
          margin-top: 12px;
          font-size: 12px;
          font-weight: 400;
          color: #8c8c8c;
          line-height: 18px;
        }
        .img {
          margin-top: 18px;
          display: flex;
          justify-content: center;
        }

        .icon-img {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
  .footer-btns {
    width: 100%;
    display: flex;
    background: #fff;
    padding: 8px 16px;
    .sub-btn {
      flex: 1;
      border-radius: 8px;
    }
  }
}
</style>
